import "Lib/jquery.magnific-popup.js";

export namespace Modals {

	export const init = () => {
		if (typeof(window['YT']) == 'undefined' || typeof(window['YT'].Player) == 'undefined') {
			let tag = document.createElement('script');

			tag.src = "https://www.youtube.com/iframe_api";
			let firstScriptTag = document.getElementsByTagName('script')[0];
			firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
		}

		let player;

		($('body') as any).magnificPopup({
			delegate: ".js-video",
			type: 'iframe',
			iframe: {
				markup: '<div class="mfp-iframe-scaler">' +
					'<div class="mfp-close"></div>' +
					'<iframe id="player" width="1280" height="720" allow="autoplay" class="mfp-iframe" frameborder="0" allowfullscreen></iframe>' +
					'</iframe>', // HTML markup of popup, `mfp-close` will be replaced by the close button

				patterns: {
					youtube: {
						index: 'youtube.com/', // String that detects type of video (in this case YouTube). Simply via url.indexOf(index).

						id: 'v=', // String that splits URL in a two parts, second part should be %id%
						// Or null - full URL will be returned
						// Or a function that should return %id%, for example:
						// id: function(url) { return 'parsed id'; }

						src: `//www.youtube.com/embed/%id%?enablejsapi=1&autoplay=1&rel=0&origin=${window.location.protocol}//${window.location.host}` // URL that will be set as a source for iframe.
					}
				},

				srcAction: 'iframe_src', // Templating object key. First part defines CSS selector, second attribute. "iframe_src" means: find "iframe" and set attribute "src".
			},
			// The magic is here :)
			callbacks: {
				open: function () {
					player = new window['YT'].Player('player', {  // player - our iframe ID
						autoplay: '1',
						events: {
							'onReady': onPlayerReady,
							'onStateChange': onPlayerStateChange, // close popup window when video end
							// 'onPlaybackQualityChange': onPlayerPlaybackQualityChange // just check everyting works
						}
					});
				},
			},
			mainClass: 'modal-zoom'
		});

		$('.js-inline-modal').each(function(){
			let $this = $(this);
			$this.on('click', function (e) {
				var $href = $(this).attr('href');
				e.preventDefault();

				($ as any).magnificPopup.open({
					items: {
						src: $href
					},
					type:'inline',
					midClick: true,
					alignTop:false,
					closeBtnInside: true,
					mainClass: 'modal-zoom'
				});
			});
		});

		if($('.js-image-modal').length) {
			($('.js-image-modal') as any).magnificPopup({
				type: 'image',
				mainClass: 'modal-zoom',
				midClick: true,
				alignTop:false,
				closeBtnInside: true
			});
		}

		$('body').on('click', '.js-modal', function(e) {
			var $href = $(this).attr('href');
			e.preventDefault();
			$('body').addClass('iframe-general');

			($ as any).magnificPopup.open({
				items: {
					src: $href
				},
				iframe: {
					markup: '<div class="mfp-iframe-scaler">'+
						'<div class="mfp-close"></div>'+
						'<iframe class="mfp-iframe" scrolling="no" frameborder="0" allowfullscreen></iframe>'+
						'</div>'
				},
				type: 'iframe',
				callbacks: {
					markupParse: function(template, values, item) {
						template.find('iframe').addClass('general-iframe');
					},
					close: function() {
						$('body').removeClass('iframe-general');
					}
				},
				mainClass: 'modal-zoom'
			});
		})

		function onPlayerReady(event) {
			event.target.setVolume(100);
			event.target.playVideo();
		}

		function onPlayerStateChange(event) {
			//0 ended, playing 1, unstarted -1, paused 2, buffering 3, cued 5
			if (event.data == 0) {
				event.target.stopVideo();
			}
		}
	}
}
